<template lang="pug">
  .svg-container
    v-fa.map-marker(icon="map-marker-alt" symbol="map-marker")
    svg(xmlns='http://www.w3.org/2000/svg' viewBox="0 0 800 800")
      mask#myMask
        circle(cx="360" cy="360" r="360" fill="#fff")
      circle(cx="400" cy="400" r="380" fill="none" stroke="#11aaee" stroke-dasharray="5 5" stroke-opacity="0.5")
      g(transform="translate(40, 40)")
        image(xlink:href="images/map/map.jpg" x="0" y="0" height="720" width="720" mask="url(#myMask)")
        g(v-for="(stage, index) in stages"
          @click="onClick(index)"
          @touchstart="onHover(index)"
          @mouseenter="onHover(index)"
          :class="{'current' : (current-1 == index)}"
          class="text-blue-600 hover:text-red-500 cursor-pointer"
          :transform="`translate(${markerPostion[index]})`"
        )
          g.map-marker-inner
            circle(cx="0" cy="-22" r="8" fill="#fff")
            use(stroke="#fff" stroke-width="36" x="-18" y="-36" width="36" height="36" xlink:href='#map-marker')
</template>
<style lang="sass" scoped>
.svg-container
  @apply relative
  &::after
    content: ''
    padding-bottom: 100%
    @apply block
svg
  @apply absolute inset-0
.current
  @apply text-red-500
.map-marker-inner
  transform: scale(1.625, 1.625)
  @screen md
    transform: none
</style>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: 0
    },
    stages: {
      type: Array
    }
  },
  data() {
    return {
      markerPostion: [
        "280 310",
        "235 290",
        "30 320",
        "290 495",
        "288 429",
        "360 500",
        "325 272",
        "520 280"
      ]
    };
  },
  methods: {
    onClick(index) {
      if (this.isTouchDevice) {
        if (this.current == index + 1) {
          this.$emit("click", index + 1);
        } else {
          this.$emit("hover", index + 1);
        }
      } else {
        this.$emit("click", index + 1);
      }
    },
    onHover(index) {
      this.$emit("hover", index + 1);
    }
  }
};
</script>
